const AntMark = ({ size = 30, dark = false, testId = "ant-mark", className = "" }) => {
  const line = dark ? "#CCFF00" : "#0A0A0A";
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      aria-hidden="true"
      className={`ant-logo ${className}`}
      data-testid={testId}
    >
      <g stroke={line} strokeWidth="2" strokeLinecap="round" className="ant-logo-legs">
        <path d="M14 13 L6 8" />
        <path d="M13 15 L4 15" />
        <path d="M14 17 L7 22" />
        <path d="M18 13 L26 8" />
        <path d="M19 15 L28 15" />
        <path d="M18 17 L25 22" />
      </g>
      <g className="ant-logo-body">
        <ellipse cx="16" cy="22" rx="5" ry="6" fill="#CCFF00" stroke="#0A0A0A" strokeWidth="1.8" />
        <circle cx="16" cy="14.5" r="3.4" fill="#CCFF00" stroke="#0A0A0A" strokeWidth="1.8" />
        <circle cx="16" cy="8" r="3.8" fill="#CCFF00" stroke="#0A0A0A" strokeWidth="1.8" />
      </g>
      <g stroke={line} strokeWidth="2" strokeLinecap="round" className="ant-logo-antennae">
        <path d="M13.5 5.5 L10 1.5" />
        <path d="M18.5 5.5 L22 1.5" />
      </g>
    </svg>
  );
};

export default AntMark;
